export default __webpack_public_path__ + "locales/it/InviteDialog.json?hash=e6330b2ab27ef8b8387c18ed56f215db";